<template>
    <div v-if="screener">
        <section class="hero">
            <img :src="screenerMainImage" alt="The Forest Screamers" class="hero-image">
            <div class="hero-overlay">
                <div class="accent-line"></div>
                <h1 class="title" :style="`color: ${colors.primaryColor}`">
                    {{ screener.title }}
                </h1>
                <p class="date">Premiering {{ moment.utc(screener.screening_starts_at).local().format("lll")}}</p>
            </div>
        </section>

        <section class="bein-section">
            <div class="bein-container">
                <button class="join-button" @click="$refs.chatContainer.showDrawer = true">
                    Join Be-IN Experience
                </button>

                <div class="features-grid">
                    <div class="stats-container">
                        <div class="stat-card total-participants">
                            <div class="stat-header">
                                <div class="stat-icon">👥</div>
                                <div>
                                    <div class="stat-title">Total Participants</div>
                                    <div class="stat-value">{{ totalParticipants }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="stat-card online-users">
                            <div class="stat-header">
                                <div class="stat-icon">
                                    <div class="online-indicator"></div>
                                </div>
                                <div>
                                    <div class="stat-title">Online Users</div>
                                    <div class="stat-value">{{ totalActiveMembers }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="stat-card offline-users">
                            <div class="stat-header">
                                <div class="stat-icon">⭕</div>
                                <div>
                                    <div class="stat-title">Offline Users</div>
                                    <div class="stat-value">{{ totalParticipants - totalActiveMembers }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="feature-card">
                        <div class="feature-content">
                            <h3 class="feature-title" :style="`color: ${colors.primaryColor}`">
                                About Be-In
                            </h3>
                            <p class="feature-text" v-html="$t('screener.chatroom.user.auto.register.page.description')">
                            </p>
                        </div>

                    
                    </div>
                </div>

                <div class="features-grid mt-4">
                    <div class="feature-card">
                        <div class="feature-content">
                            <h3 class="feature-title" :style="`color: ${colors.primaryColor}`">
                                About {{ screener.title }}
                            </h3>
                            <p class="feature-text" v-html="screener.films[0].description">
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <template v-if="screener">
            <ChatContainer 
                ref="chatContainer"
                :screener="screener" 
                :showDefaultBeInButton="false"
                :showBeInRegister="false"
                @update-total-participants="updateTotalParticipants"
                @update-total-active-members="updateTotalActiveMembers"
            />
        </template>
    </div>
</template>

<script>
import * as API from '@/api';
import DEFINES from "@/defines";
import { mapState } from "vuex";

// Chatroom 
import ChatContainer from "@/components/chatRoom/ChatContainer"
// Chatroom 

export default {
    name : 'ChattingOverview',
    data(){
        return {
            isPageLoading: true,
            screener: null,
            totalParticipants: 0,
            totalActiveMembers: 0,
        }
    },
    components:{
        ChatContainer
    },
    async mounted() {
        if (this.$route.params.screener_id) {
            await this.getScreenerFromApi();
        }
    },
    computed: {
        ...mapState({
            colors: (state) => state.app.app.colors,
        }),
        screenerMainImage() {
            if (this.screener && this.screener.thumbnail_url ) {
                return this.screener.thumbnail_url;
            }else if(this.screener.films[0].thumburls) {
                return this.screener.films[0].thumburls[0];
            }
        }
    },
    methods: {
        async getScreenerFromApi() {
            try {
                let response = await this.$store.dispatch("screening/get", {
                    id: this.$route.params.screener_id
                });
                this.screener = response.screener;
            } catch (error) {
                await this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: "error"
                });
                
            }
        },
        updateTotalParticipants(newVal) {
            console.log('This is Total Prticipants');
            
            this.totalParticipants = newVal;
        },
        updateTotalActiveMembers(newVal) {
            console.log('This is Active Prticipants');
            this.totalActiveMembers = newVal;
        }
    },
          
}
</script>

<style scoped>
.hero {
    position: relative;
    height: 70vh;
    width: 100%;
    overflow: hidden;
}

.hero-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(0.6);
}

.hero-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 8rem 2rem 2rem;
    background: linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);
}

.accent-line {
    height: 4px;
    width: 60px;
    background: linear-gradient(to right, #34d399, #ec4899);
    margin-bottom: 1.5rem;
}

.title {
    font-size: 3.5rem;
    margin-bottom: 1rem;
    font-weight: 600;
}

.date {
    font-size: 1.25rem;
    color: #9ca3af;
    margin-bottom: 2rem;
}

.bein-section {
    max-width: 1200px;
    margin: -29px auto 0;
    padding: 0 2rem;
    position: relative;
    z-index: 10;
}

.bein-container {
    background: rgba(23, 23, 23, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    padding: 2rem;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 20px 40px rgba(0,0,0,0.4);
}

.live-counter {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 2rem;
}

.pulse-dot {
    width: 10px;
    height: 10px;
    background-color: #ec4899;
    border-radius: 50%;
    animation: pulse 2s infinite;
}

.counter-text {
    color: #ec4899;
    font-weight: 600;
    font-size: 1.125rem;
}

.join-button {
    width: 100%;
    background: linear-gradient(45deg, #34d399, #ec4899);
    color: white;
    border: none;
    padding: 1.5rem;
    border-radius: 15px;
    font-size: 1.25rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-bottom: 2rem;
    position: relative;
    overflow: hidden;
}

.join-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.2),
        transparent
    );
    transition: 0.5s;
}

.join-button:hover::before {
    left: 100%;
}

.features-grid {
    display: grid;
    /* grid-template-columns: repeat(2, 1fr); */
    gap: 1.5rem;
}

.feature-card {
    background: rgba(255, 255, 255, 0.05);
    padding: 1.5rem;
    border-radius: 15px;
    display: flex;
    align-items: center;
    gap: 1rem;
    transition: all 0.3s ease;
}

.feature-card:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
}

.feature-icon {
    color: #34d399;
    font-size: 2.5rem;
}

.feature-content {
    flex: 1;
}

.feature-title {
    font-weight: bolder;
    margin-bottom: 0.25rem;
    font-size: 1.7rem;
}

.feature-text {
    color: #9ca3af;
    font-size: 1.3rem;
}

@keyframes pulse {
    0% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.2); opacity: 0.5; }
    100% { transform: scale(1); opacity: 1; }
}

@media (max-width: 768px) {
    .hero {
        height: 50vh;
    }
    
    .title {
        font-size: 2.5rem;
    }

    .bein-section {
        margin-top: -50px;
    }

    .features-grid {
        grid-template-columns: 1fr;
    }
}

.stats-container {
    display: flex;
    gap: 1.5rem;
    margin-top: 2rem;
}

.stat-card {
    flex: 1;
    background: linear-gradient(to right, rgba(32, 32, 32, 0.8), rgba(24, 24, 24, 0.8));
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    transition: transform 0.2s ease;
}

.stat-card:hover {
    transform: translateY(-2px);
}

.stat-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 0.5rem;
}

.stat-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.total-participants .stat-icon {
    background: rgba(255, 107, 0, 0.1);
    color: #ff6b00;
}

.online-users .stat-icon {
    background: rgba(74, 222, 128, 0.1);
    color: #4ade80;
}

.offline-users .stat-icon {
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
}

.stat-title {
    color: #999;
    font-size: 0.9rem;
}

.stat-value {
    font-size: 1.8rem;
    font-weight: 600;
    color: white;
}

.online-indicator {
    width: 12px;
    height: 12px;
    background-color: #4ade80;
    border-radius: 50%;
    position: relative;
    animation: pulse 2s infinite;
}


.online-indicator::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #4ade80;
    opacity: 0.4;
    z-index: -1;
}

@keyframes pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(74, 222, 128, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(74, 222, 128, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(74, 222, 128, 0);
    }
}
</style>